import { render } from "./ProductCategoryPage.vue?vue&type=template&id=2b1fae94&scoped=true"
import script from "./ProductCategoryPage.vue?vue&type=script&lang=js"
export * from "./ProductCategoryPage.vue?vue&type=script&lang=js"

import "./ProductCategoryPage.vue?vue&type=style&index=0&id=2b1fae94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1fae94"]])

export default __exports__